<template>
  <nav ref="nav-bar"
       class="nav-bar nav-bar--pc"
       :class="{'nav-bar--black' : isNavBarBlack, 'nav-bar--hover' : canNavBarBeHovered}"
       @mouseleave="shrinkMenuItemIndicator"
  >
    <div class="nav-bar__wrapper">
      <div class="nav-bar__logo">
        <div class="logo-ctn" @click="goToHomePage">
          <img src="@/assets/images/onesti-logo/onesti.svg" class="onesti" alt="Onesti">
          <img src="@/assets/images/onesti-logo/a-symbol.svg" class="a-symbol" alt="Onesti">
          <img src="@/assets/images/onesti-logo/a-symbol-white.svg" class="a-symbol a-symbol--white" alt="Onesti">
          <img :src="$getImage(`onesti-logo/dvogados-${currentLocale}.svg`)" class="dvogados" alt="Onesti">
        </div>
      </div>
      <div class="nav-bar__divider" />
      <div v-if="isInPageOtherThanHome" class="nav-bar-menu-ctn" @mouseenter="canNavBarBeHovered = false">
        Onesti Advogados
      </div>
      <div v-else class="nav-bar-menu-ctn">
        <span ref="nav-bar-title" class="nav-bar-title">
          {{ currentSection ? $t(`${currentSection}.title`) : $t('navBar.title') }}
        </span>
        <div class="nav-bar-menu">
          <div class="nav-bar-menu-item" @mouseenter="revealSubMenu">
            <span class="nav-bar-menu-item__title">{{ $t('navBar.menuTitle.office') }}</span>
            <ul class="nav-bar-menu-item__submenu">
              <li v-for="(pair, index) in $t('navBar.subMenu.office')" class="menu-link" :data-to="officeSubMenuNames[index]">
                <span v-for="item in pair" @click="goToSection">
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>
          <div class="nav-bar-menu-item" @mouseenter="revealSubMenu">
            <span class="nav-bar-menu-item__title">{{ $t('navBar.menuTitle.practice') }}</span>
            <ul class="nav-bar-menu-item__submenu">
              <li v-for="(pair, index) in $t('navBar.subMenu.practice')" class="menu-link" :data-to="practiceSubMenuNames[index]">
                <span v-for="item in pair" @click="goToSection">
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>
          <div class="nav-bar-menu-item" @mouseenter="revealSubMenu">
            <span class="nav-bar-menu-item__title">{{ $t('navBar.menuTitle.recognition') }}</span>
            <ul class="nav-bar-menu-item__submenu">
              <li v-for="(pair, index) in $t('navBar.subMenu.recognition')" class="menu-link" :data-to="recognitionSubMenuNames[index]">
                <span v-for="item in pair" @click="goToSection">
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>
          <div class="nav-bar-menu-item" @mouseenter="revealSubMenu">
            <span class="nav-bar-menu-item__title">{{ $t('navBar.menuTitle.socialMedia') }}</span>
            <ul class="nav-bar-menu-item__submenu nav-bar-menu-item__submenu--medias">
              <li class="menu-link">
                <a href="https://www.facebook.com/Onestilaw/" target="_blank">Facebook</a>
              </li>
              <li class="menu-link">
                <a href="https://pt.linkedin.com/company/onestilaw" target="_blank">Linkedin</a>
              </li>
              <li class="menu-link">
                <a href="https://www.instagram.com/Onestilaw/" target="_blank">Instagram</a>
              </li>
              <li class="menu-link">
                <a href="https://x.com/Onestilaw/" target="_blank">X</a>
              </li>
              <li class="menu-link">
                <a href="https://www.youtube.com/onesti-advogados" target="_blank">Youtube</a>
              </li>
              <li class="menu-link">
                <a href="https://www.yelp.com.br/biz/onesti-advogados-s%C3%A3o-paulo-2" target="_blank">Yelp</a>
              </li>
            </ul>
          </div>
          <div class="nav-bar-menu__divider" />
          <div ref="menu-item-indicator" class="menu-item-indicator" />
        </div>
      </div>
      <div class="nav-bar-languages-menu" @mouseenter="canNavBarBeHovered = true">
        <span class="nav-bar-languages-menu__title">
          {{ $t('navBar.language') }}
          <font-awesome-icon icon="globe" class="ml-1" />
        </span>
        <div class="nav-bar-languages-list">
          <div class="nav-bar-language" @click="changeLanguage('pt')">
            Português
          </div>
          <div class="nav-bar-language" @click="changeLanguage('en')">
            English
          </div>
          <div class="nav-bar-language" @click="changeLanguage('es')">
            Español
          </div>
          <div class="nav-bar-language" @click="changeLanguage('cn')">
            中国
          </div>
        </div>
      </div>
    </div>
    <div class="nav-bar__background" />
  </nav>
</template>

<script>
import { TweenLite } from 'gsap'
require('../../node_modules/gsap/ScrollToPlugin')

export default {
  name: 'NavBarPc',
  data () {
    return {
      officeSubMenuNames: [
        'unique',
        'from',
        'see',
        'think',
        'live',
        'practice'
      ],
      practiceSubMenuNames: [
        'have',
        'ready',
        'solutions',
        'performance'
      ],
      currentSection: undefined,
      isNavBarBlack: false,
      indicator: undefined,
      indicatorOffset: undefined,
      indicatorWidth: undefined,
      canNavBarBeHovered: true
    }
  },
  computed: {
    recognitionSubMenuNames () {
      return [
        'been',
        this.$i18n.locale === 'pt' ? 'testimony' : 'cases',
        this.$i18n.locale === 'pt' ? 'cases' : undefined
      ]
    },
    currentLocale () {
      return this.$i18n.locale
    },
    routeName () {
      return this.$route.name
    },
    isInPageOtherThanHome () {
      const pagesName = ['modern-slavery-lang', 'green-politic-lang', 'general-politic-lang', 'anti-corruption-lang', 'legal-advice-lang']
      let result
      pagesName.every(page => {
        if (page === this.routeName) {
          result = true
          return false
        }
        return true
      })
      return result
    }
  },
  methods: {
    changeLanguage (lang) {
      const currentRoute = this.$route.name
      let routeName
      if (currentRoute === 'root') routeName = 'home'
      else if (currentRoute.includes('lang')) routeName = currentRoute
      else routeName = currentRoute + '-lang'
      this.$router.push({
        name: routeName,
        params: {
          lang
        }
      })
      this.$store.dispatch('cleanAccordionsArr')
    },
    goToHomePage () {
      this.$router.push({ name: 'home' })
    },
    revealSubMenu ({ target }) {
      const hoveredElementLeft = target.getBoundingClientRect().left
      const hoveredElementTitle = target.childNodes[0]
      const hoveredElementTitleWidth = hoveredElementTitle.getBoundingClientRect().width
      const positionToGo = parseFloat(hoveredElementLeft.toFixed(2))
      const widthToExpand = parseFloat(hoveredElementTitleWidth.toFixed(2))
      this.indicator.style.transform = `
        translateX(${positionToGo - this.indicatorOffset}px)
        scaleX(${widthToExpand / this.indicatorWidth})
      `
    },
    shrinkMenuItemIndicator () {
      if (!this.isInPageOtherThanHome) this.indicator.style.transform = 'translateX(0) scaleX(0)'
    },
    prepareMenuIndicator () {
      this.$nextTick(() => {
        try {
          this.indicator = this.$refs['menu-item-indicator']
          this.indicatorOffset = parseFloat(this.indicator.getBoundingClientRect().left.toFixed(2))
          this.indicatorWidth = this.indicator.getBoundingClientRect().width
        } catch (e) {
          // fail silently
        }
      })
    },
    goToSection ({ target }) {
      const sectionName = target.parentNode.getAttribute('data-to')
      TweenLite.to(window, 1, { scrollTo: `section[data-name=${sectionName}]`, autoKill: false })
    }
  },
  watch: {
    isInLegalAdvicePage (val) {
      this.canNavBarBeHovered = !val
      this.prepareMenuIndicator()
    },
    routeName () {
      this.isNavBarBlack = this.isInPageOtherThanHome
    }
  },
  created () {
    if (this.isInPageOtherThanHome) this.isNavBarBlack = true
  },
  mounted () {
    this.prepareMenuIndicator()
    this.$root.$on('nav-bar-black', () => { this.isNavBarBlack = true })
    this.$root.$on('nav-bar-transparent', () => { this.isNavBarBlack = false })
    this.$root.$on('current-section-change', (section) => { this.currentSection = section })
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

$height: 80px
$transition-time: .4s
$nav-bar-menu-width: 600px
$divider-offset: 85%
$item-menu-subtitle-divider-offset: 10px
$item-menu-subtitle-divider-height: 15px

.nav-bar
  @apply fixed z-50 pin-t pin-l hidden text-white w-full
  height: $height
  transition: background $transition-time
  @screen xl
    @apply block
  &__wrapper
    @apply relative z-10 flex items-center justify-center w-full h-full px-2
  &__logo
    @apply flex items-center w-full h-full
    flex: 1 0 115px
  &__divider
    @apply h-3/5 w-px ml-2 mr-3
    background: rgba(255, 255, 255, 0.6)
  &__background
    @apply absolute pin-t pin-l opacity-0 w-full h-full
    background: rgba(0, 0, 0, 0.8)
    transform-origin: center top
    transform: scaleY(0)
    transition: transform $transition-time cubic-bezier(.04,.77,.57,1.01), opacity $transition-time
  &--black
    background: rgba(0, 0, 0, 0.5)
    .onesti, .dvogados
      @apply opacity-0
    .a-symbol
      transform: scale(5) translateX(3px)
      &--white
        @apply opacity-100
    &:hover
      .a-symbol--white
        @apply opacity-0

.logo-ctn
  @apply relative cursor-pointer w-full
  height: 52px

.onesti
  @apply absolute
  width: 100px
  transition: opacity .4s

.dvogados
  @apply absolute
  top: 40px
  left: 22px
  width: 60px
  transition: opacity .4s

.a-symbol
  @apply absolute
  top: 41px
  left: 13px
  width: 8px
  transform-origin: left bottom
  transition: transform .5s, opacity .3s
  &--white
    @apply z-10 opacity-0

.nav-bar-menu-ctn
  @apply relative flex items-center w-full h-full

.nav-bar-title
  @apply cursor-pointer opacity-100
  transition: opacity .3s
  font-size: 18px
  height: 26px

.nav-bar-menu
  @apply absolute pin-t pin-l flex opacity-0 h-full
  transition: opacity $transition-time
  width: $nav-bar-menu-width
  &__divider
    @apply absolute w-full h-px
    top: $divider-offset
    background: rgba(255, 255, 255, 0.3)
    transform-origin: left center
    transition: transform #{$transition-time} + .6s  cubic-bezier(.14,.68,.21,1) .2s
    transform: scaleX(0)

.nav-bar-menu-item
  @apply absolute half-t -translate-y-50
  & > span
    @apply cursor-pointer
  &__title
    @apply inline-block
    font-size: 18px
    height: 26px
  &__submenu
    @apply absolute pin-l whitespace-no-wrap pointer-events-none m-0 pl-0
    top: calc(100% + 20px)
    li
      @apply flex cursor-pointer opacity-0 pointer-events-none
      padding: .3rem 0
      transition-property: opacity
      transition-duration: .2s
      span:first-child
        @apply relative
        margin-right: $item-menu-subtitle-divider-offset
        &::after
          @apply no-content absolute bg-white w-px opacity-50
          bottom: 3px
          right: #{-$item-menu-subtitle-divider-offset}
          height: $item-menu-subtitle-divider-height
      span:last-child
        margin-left: $item-menu-subtitle-divider-offset
        color: #c2c2c2
    &--medias
      li
        span:last-child
          @apply text-white m-0
          &::after
            @apply hidden
  &:nth-child(1)
    li
      @each $index, $delay in (6, 1), (5, 2), (4, 3), (3, 4), (2, 5), (1, 6)
        &:nth-child(#{$index})
          transition-delay: #{$delay / 40 s}
  &:nth-child(2)
    left: 100px
    li
      @each $index, $delay in (4, 1), (3, 2), (2, 3), (1, 4)
        &:nth-child(#{$index})
          transition-delay: #{$delay / 40}s
  &:nth-child(3)
    left: 188px
    li
      @each $index, $delay in (3, 1), (2, 2), (1, 3)
        &:nth-child(#{$index})
          transition-delay: #{$delay / 40}s
  &:nth-child(4)
    left: 352px
    li
      @each $index, $delay in (6, 1), (5, 2), (4, 3), (3, 4), (2, 5), (1, 6)
        &:nth-child(#{$index})
          transition-delay: #{$delay / 40}s

.menu-item-indicator
  @apply absolute pin-l bg-white
  top: calc(#{$divider-offset} - 1px)
  width: 74px
  height: 2px
  transform-origin: left center
  transition: transform $transition-time

// Hover Behaviors
.nav-bar--hover:hover
  .nav-bar
    &__background
      @apply opacity-100
      transform: scaleY(3.5)
  .nav-bar-title
    @apply opacity-0
  .nav-bar-menu
    @apply opacity-100
    &__divider
      transform: scaleX(1)
  .nav-bar-menu-item
    top: calc(50% - 26px / 2)
    transform: none
    &__submenu
      @apply relative
      top: 20px

.nav-bar-menu-item:hover
  .nav-bar-menu-item
    &__submenu
      .menu-link
        @apply opacity-100 pointer-events-auto
        @for $i from 1 through 6
          &:nth-child(#{$i})
            transition-delay: #{$i / 20}s

.menu-link
  & > *
    @apply text-white no-underline
  &:hover
    & > *:first-child
      @apply text-pink

.nav-bar-languages-menu
  $title-height: 22px
  @apply relative text-lg cursor-pointer
  &:hover
    height: 110px
    margin-top: calc(110px - #{$title-height})
    .nav-bar-languages-list
      @apply pointer-events-auto opacity-100
  &__title
    @apply relative inline-flex items-center pl-2
    height: $title-height
    &::after
      @apply no-content absolute pin-t pin-l bg-white w-px h-full
.nav-bar-languages-list
  @apply absolute pin-r text-right pointer-events-none opacity-0
  transition: opacity .3s

.nav-bar-language
  @apply py-1
  &:hover
    @apply text-pink
</style>
